import { IBlogPreviewContent, IPageTranslation } from './interfaces';

const BLOG_COMPONENT_NAME = 'BlogArticle';

// tslint:disable-next-line:quotemark
const getComponentList = (content: IPageTranslation["content"]["content"]) => {
    // tslint:disable-next-line:quotemark
    const foundComponents = Array.isArray(content) && content.reduce((acc: string[], contentItem: IPageTranslation["content"]["content"][number]) => {
        if ('container' === contentItem.type) {
            const innerComponents = getComponentList(contentItem.content);
            acc.push(...(innerComponents.filter(c => acc.indexOf(c) < 0)));
        } else if ('component' === contentItem.type && acc.indexOf(contentItem.name) < 0) {
            acc.push(contentItem.name);
        }
        return acc;
    }, [] as string[]) || []; // tady musí být as string[], jinak to nejde použít jako komponenta na frontendu

    return foundComponents;
};

export const getComponentsInTranslation = (translation: IPageTranslation): string[] => {
    const foundComponents = translation.content && getComponentList(translation.content.content) || [];

    return foundComponents;
};

export const isBlogPage = (translations: IPageTranslation[]): boolean => {
    return Array.isArray(translations) && translations.reduce((acc: boolean, translation) => {
        acc = acc || getComponentsInTranslation(translation).indexOf(BLOG_COMPONENT_NAME) > -1;
        return acc;
    }, false as boolean); // tady musí bý as boolean, jinak to nejde použít jako komponenta na frontendu
};

export const extractPreviewContent = (translation: IPageTranslation, createdAt: string): IBlogPreviewContent | undefined => {
    if (!Array.isArray(translation.annotations)) {
        return undefined;
    }
    // tslint:disable-next-line:quotemark
    const titleAnnotation = translation.annotations.find((a: IPageTranslation["annotations"][number]) => a.key === 'title');
    // tslint:disable-next-line:quotemark
    const imageAnnotation = translation.annotations.find((a: IPageTranslation["annotations"][number]) => a.key === 'image');
    const url = translation.url;

    return {
        title: titleAnnotation && titleAnnotation.value,
        image: imageAnnotation && imageAnnotation.value && (() => {
            try {
                return JSON.parse(imageAnnotation.value);
            } catch {
                return undefined;
            }
        })(),
        url,
        date: new Date(createdAt),
    };
};


// WEBPACK FOOTER //
// ../helpers/src/externalBlog/helpers.ts